class VideoPauseClick extends HTMLElement {
  constructor() {
    super();
    const muteButton = this.querySelector('[id^="Toggle-Mute-"]');
    const playPauseButton = this.querySelector('[id^="Toggle-Play-"]');
    this.media = muteButton.dataset.media;
    this.video = this.querySelector(`#${this.media}`);
    if (!muteButton) return;
    muteButton.addEventListener('click', this.toggleMute.bind(this));
    if (!playPauseButton) return;
    playPauseButton.addEventListener('click', this.togglePlay.bind(this));

    this.video.addEventListener('pause', this.paused.bind(this));
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    this.setAttribute('muted', this.video.muted);
  }
  togglePlay() {
    if (this.video.paused || this.video.ended) {
      window.pauseAllMedia();
      this.video.play();
      this.closest('deferred-media').setAttribute('loaded', true);
      this.setAttribute('playing', true);
    } else {
      this.video.pause();
      this.setAttribute('playing', false);
    }
  }

  paused() {
    this.closest('deferred-media').setAttribute('loaded', false);
    this.setAttribute('playing', false);
  }
}

customElements.define('video-pause-click', VideoPauseClick);
